import { logger } from "../default-logger";
import _ from "lodash"

export const appendParamsToURL = (url, params) => {
    logger.debug('append params', url, params);
    if (Object.keys(params)?.length > 0) {
        url += `&params={`
        for (const param in params) {
            let value = '';
            if (Array.isArray(params[param].value) || Array.isArray(params[param])) {
                // logger.debug('append arr detected', params[param]);
                value = '[';
                const arr = params[param].value ?? params[param] ?? [];
                for (const paramValue of arr) {
                    // logger.debug('cur arr value:', paramValue);
                    value += `${paramValue.value || paramValue},`;
                }
                value = value.slice(0, -1) + ']'; // remove the trailing comma
            } else value = params[param].value || params[param];
            url += `${param}:${value},`
            logger.debug('cur value:', value, params[param], Array.isArray(Array.from(params[param])), Array.from(params[param]));
        }
        url = url.slice(0, -1);
        url += '}'
    }
    return url;
}